import { type WebhookType } from 'crm-atoms/types';

export const listWebhooksQuery = `
query webhooks($ids: [ID!]!) {
  webhooks(id: $ids) {
    id
    name
    meta
    status
    maxRetries
    saveResponse
    notifyOnFailure
  }
}
`;

export interface ListWebhooksQuery {
  webhooks: WebhookType[];
}
